export default __webpack_public_path__ + "static/media/icon_pages_button_share_enabled.9ecab2ee.svg";